import type ModalV2 from '/@/components/bayer/modal-v2';
import { useIsValidatedAdvisor, useIsValidatedRV } from '/@/hooks/session';
import AdvisorOnboardingModalAndAlert from './advisor-onboarding-modal';
import RVOnboardingModalAndAlert from './rv-onboarding-modal';

export interface InvitedAdvisorInfo {
    id: number;
    name: string;
    distributor: string;
}

export const modalProps: Pick<React.ComponentProps<typeof ModalV2>, 'maxWidth' | 'actionsProps' | 'bodyProps'> = {
    maxWidth: 'lg',
    actionsProps: {
        sx: {
            justifyContent: 'flex-end',
        },
    },
    bodyProps: {
        sx: {
            p: { xs: 2, md: 5 },
            alignItems: 'center',
        },
        spacing: 5,
    },
};

export const modalBodyPropsWide = {
    maxWidth: '800px' as const,
    textAlign: 'start' as const,
    mx: 'auto',
};

export const ONBOARDING_RV_ADVISOR_LINKED_STORAGE_KEY = 'rv-onboarding-advisor-linked';

export const OnboardingModalAndAlert = () => {
    const isRV = useIsValidatedRV();
    const isAdvisor = useIsValidatedAdvisor();
    if (isAdvisor) return <AdvisorOnboardingModalAndAlert />;
    if (isRV) return <RVOnboardingModalAndAlert />;
    return null;
};
